import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { LandingService } from 'src/app/core/services/landing.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LandingComponent implements OnInit, AfterViewInit, OnDestroy {
  champSession: any;
  constructor(
    private layoutService: LayoutService,
    private storageService: StorageService,
    private landingService: LandingService,
    @Inject(DOCUMENT) private document: Document
  ) {
    console.log('this.storageService.resource', this.storageService.resource)
    if (!this.storageService.resource) {
      this.layoutService.getResource(this.storageService.language).subscribe(
        res1 => {
          console.log(res1);
          this.storageService.resource = res1;
          this.content = this.storageService.resource?.landing;
          this.commonContent = this.storageService.resource?.commonContent;
        },
        (err) => {
          console.log(err.message);
        }
      );
    }
    else {
      this.content = this.storageService.resource?.landing;
      this.commonContent = this.storageService.resource?.commonContent;
    }
  }

  content; //= this.storageService.resource?.landing;
  commonContent;// = this.storageService.resource?.commonContent;
  ngOnInit(): void {
    // Set user profile detail into local storage.
    this.champSession = this.storageService;
    if (this.storageService.loggednUser) {
        //if (this.storageService.userId && this.storageService.selectedType && this.storageService.loggednUser) {
          this.landingService.getSimulationCount(this.storageService.userId, this.storageService.tenantId, 0, 0)
            .subscribe((res) => {
              this.storageService.totalSimulation = res.simulationCount;
            });
          this.landingService.getBaseLineCount(this.storageService.userId, this.storageService.tenantId, 0)
            .subscribe((res) => {
              this.storageService.totalBaseLine = res.baseLineCount;
            });
        //}
    }
  }

  ngAfterViewInit(): void {
    // Adding style class on body for landing page.
    this.document.body.classList.add('landing-body');
  }

  ngOnDestroy(): void {
    // Remove style class on body for landing page.
    this.document.body.classList.remove('landing-body');
  }

}
